import { composeIO } from 'react-compose-io'
import { parametrosSelecionarIO } from './ParametrosSelecionar.IO'
import ParametrosSelecionarView from './ParametrosSelecionar.View'

export const ParametrosSelecionar = composeIO(ParametrosSelecionarView, parametrosSelecionarIO)
